function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicFill = function SvgMicFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff5c7f"
    },
    d: "M13.844 19.338c2.643 0 4.797-2.115 4.797-4.717V6.688c0-2.583-2.15-4.688-4.797-4.688C11.2 2 9.046 4.1 9.046 6.688v7.966c.005 2.583 2.154 4.684 4.798 4.684Z",
    fill: "#FF5C7F"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff5c7f"
    },
    d: "M20.858 10.64a.82.82 0 0 0-.83.812v3.197c0 3.334-2.773 6.044-6.184 6.044s-6.18-2.71-6.18-6.039v-3.197a.821.821 0 0 0-.83-.812.825.825 0 0 0-.834.812v3.197c0 3.952 3.075 7.215 7.014 7.623v2.1h-2.605a.82.82 0 0 0-.83.812c0 .45.374.811.83.811h6.874a.82.82 0 0 0 .83-.811.821.821 0 0 0-.83-.811h-2.605v-2.1c3.94-.409 7.014-3.672 7.014-7.624v-3.197a.826.826 0 0 0-.834-.816Z",
    fill: "#FF5C7F"
  }));
};
export default SvgMicFill;